import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";

const WishlistPage = () => {
  const { user } = useContext(AuthContext);
  const token = localStorage.getItem("token");
  const [wishlist, setWishlist] = useState([]);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      // ✅ Logged-in user → fetch wishlist from API
      axios
        .get("https://cartbackend.wsdstech.com/api/wishlist", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => setWishlist(res.data || []))
        .catch((err) => console.error("Wishlist fetch error:", err));
    } else {
      // ✅ Guest user → fetch wishlist from localStorage
      const guestWishlist = JSON.parse(localStorage.getItem("guestWishlist")) || [];
      setWishlist(guestWishlist.map((id) => ({ product_id: id })));
    }

    // Fetch all products (for details)
    axios
      .get("https://cartbackend.wsdstech.com/api/products")
      .then((res) => setProducts(res.data || []))
      .catch((err) => console.error("Products fetch error:", err));
  }, [user, token]);

  const handleRemove = (productId) => {
    if (token) {
      axios
        .delete(`https://cartbackend.wsdstech.com/api/wishlist/${productId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => {
          setWishlist((prev) => prev.filter((item) => item.product_id !== productId));
        });
    } else {
      let guestWishlist = JSON.parse(localStorage.getItem("guestWishlist")) || [];
      guestWishlist = guestWishlist.filter((id) => id !== productId);
      localStorage.setItem("guestWishlist", JSON.stringify(guestWishlist));
      setWishlist(guestWishlist.map((id) => ({ product_id: id })));
    }
  };

const handleAddToCart = (product, qty = 1) => {
  if (!token) {
    // ✅ Guest user → store in localStorage
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const existingIndex = cart.findIndex((item) => item.product_id === product.id);

    if (existingIndex >= 0) {
      cart[existingIndex].quantity += qty;
    } else {
      cart.push({
        product_id: product.id,
        name: product.name,
        price: product.price,
        quantity: qty,
        image: product.image_url,
      });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    alert("✅ Added to cart (Guest mode)!");

    // 🔥 Remove from wishlist after adding to cart
    handleRemove(product.id);
    window.location.reload();

    return;
  }

  // ✅ Logged-in user → backend API
  axios
    .post(
      "https://cartbackend.wsdstech.com/api/cart",
      { product_id: product.id, quantity: qty, price: product.price },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then(() => {
      alert("✅ Added to cart (Logged-in)!");

      // 🔥 Remove from wishlist after adding to cart
      handleRemove(product.id);
      window.location.reload();
    })
    .catch((err) => {
      alert("❌ Error: " + (err.response?.data?.message || "Something went wrong"));
    });
};


  // Merge wishlist with product details
  const wishlistWithDetails = wishlist
    .map((wish) => {
      const product = products.find((p) => p.id === wish.product_id);
      return product ? { ...wish, ...product } : null;
    })
    .filter(Boolean);

  return (
    <div className="container my-5">
      <h2 className="mb-4">Your Wishlist</h2>
      {wishlistWithDetails.length === 0 ? (
        <p>No items in your wishlist yet.</p>
      ) : (
        <div className="row">
          {wishlistWithDetails.map((item) => (
            <div className="col-md-4 mb-4" key={item.product_id}>
              <div className="card h-100">
                <img
                  src={item.image_url || "https://via.placeholder.com/150"}
                  className="card-img-top"
                  alt={item.name}
                />
                <div className="card-body">
                  <h5 className="card-title">{item.name}</h5>
                  <p className="card-text">₹ {item.price}</p>
                  <Link
                    to={`/product/${item.product_id}`}
                    className="btn btn-primary btn-sm me-2"
                  >
                    View Product
                  </Link>
                 
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleRemove(item.product_id)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WishlistPage;
